import type {ReactElement} from 'react';
import React from 'react';
import {BottomBarItemColorFill} from '@Components/poster-editor/components/poster-editor-bottom-bar/components/bottom-bar-item-color-fill';
import {useGetKeyFromQRItem} from '@Hooks/poster-editor/useGetKeyFromQRItem';

export function QrForegroundColor(): ReactElement<any> | null {
  const itemQrForegroundColor = useGetKeyFromQRItem('qrForegroundColor');
  if (!itemQrForegroundColor) {
    return null;
  }

  return <BottomBarItemColorFill color={[itemQrForegroundColor]} />;
}
